import React from "react";
import { Box, Typography, CardContent } from "@mui/material";
import { StyledCard } from "../../common/StyledCard";
import { getEntityMeta } from "../../../helpers/dashboardHelpers";
import { SmsTemplateStatsDto } from "../../../shared/dtos/sms/SmsTemplateStatsDto";

interface SmsTemplateWidgetProps {
  data: SmsTemplateStatsDto;
}

const SmsTemplateWidget: React.FC<SmsTemplateWidgetProps> = ({ data }) => {
  const meta = getEntityMeta("SMS_TEMPLATE");
  const Icon = meta.icon;

  return (
    <StyledCard
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <CardContent sx={{ textAlign: "center" }}>
        <Box
          sx={{
            display: "inline-flex",
            p: 2,
            borderRadius: "50%",
            bgcolor: `${meta.color}15`,
            color: meta.color,
            mb: 2,
          }}
        >
          <Icon fontSize="large" />
        </Box>

        <Typography
          variant="h3"
          sx={{
            fontWeight: "bold",
            color: "text.primary",
          }}
        >
          {data.totalTemplates.toLocaleString()}
        </Typography>

        <Typography variant="body1" color="text.secondary">
          Configured Templates
        </Typography>
      </CardContent>
    </StyledCard>
  );
};

export default SmsTemplateWidget;
